import React from 'react';
import { connect } from "react-redux";
import { useDispatch } from '../reducers/store';
import { setCrumb } from '../reducers/global';
import { getSupplier, deleteSupplier, createSupplier } from '../reducers/suppliers';
import { selectAppointment } from '../reducers/calendar';
import ItemEditComponent from './TextEdit';
import Alert from './glass/GlassAlert';

const SupplierComponent = ({ addSupplier, activeTab, error, updateshowAdd, viewOnly, setViewOnly, onChangeText, cancelChanges, compare,
    dispatchSaveSupplier, setActiveTab,
}) => {

    // Exit (back) — confirm if there are unsaved changes
    const requestBack = () => {
        if (compare && compare()) { updateshowAdd(false); return; }
        Alert.fire({
            title: 'Discard unsaved changes?',
            text: 'Your changes to this supplier will be lost.',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Keep editing',
            denyButtonText: 'Discard',
        }).then((r) => { if (r.isDenied) updateshowAdd(false); });
    };

    const ghostBtn = { background: 'rgba(15,31,46,0.06)', border: '1px solid rgba(15,31,46,0.1)', color: 'var(--text-secondary)', borderRadius: 10, padding: '9px 16px', fontWeight: 600, fontFamily: 'var(--font-display)', fontSize: 13, cursor: 'pointer' };
    const saveBtn = { background: 'linear-gradient(135deg, var(--primary), var(--primary-dark))', border: 'none', color: '#fff', borderRadius: 10, padding: '9px 18px', fontWeight: 700, fontFamily: 'var(--font-display)', fontSize: 13, cursor: 'pointer', boxShadow: '0 6px 16px rgba(13,161,178,0.28)' };
    const editBtn = { background: 'linear-gradient(135deg, var(--primary), var(--primary-dark))', border: 'none', color: '#fff', borderRadius: 10, padding: '9px 16px', fontWeight: 700, fontFamily: 'var(--font-display)', fontSize: 13, cursor: 'pointer' };
    const name = addSupplier && (addSupplier.name || addSupplier.surname)
        ? `${addSupplier.name || ''} ${addSupplier.surname || ''}`.trim()
        : 'New supplier';

    // Topbar sub-breadcrumb: Suppliers › <name>
    const _crumbDispatch = useDispatch();
    React.useEffect(() => {
        _crumbDispatch(setCrumb(name));
        return () => _crumbDispatch(setCrumb(null));
    }, [name]);

    return (
        <div style={{ margin: '4px 0 24px' }}>
            {/* Editor header */}
            <div style={{ background: 'rgba(255,255,255,0.55)', WebkitBackdropFilter: 'blur(22px) saturate(1.4)', backdropFilter: 'blur(22px) saturate(1.4)', border: '1px solid var(--glass-border)', borderRadius: 16, padding: '14px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 10px 30px rgba(15,31,46,0.10)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 14, minWidth: 0 }}>
                    <button type="button" onClick={requestBack} title="Back" style={{ background: 'rgba(15,31,46,0.06)', border: 'none', color: 'var(--text-secondary)', width: 36, height: 36, borderRadius: 10, cursor: 'pointer', flexShrink: 0 }}>
                        <i className="fas fa-arrow-left"></i>
                    </button>
                    <span style={{ color: 'var(--text)', fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 20, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{name}</span>
                </div>
                <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
                    {viewOnly && <button type="button" onClick={() => setViewOnly(false)} style={editBtn}><i className="fas fa-edit" style={{ marginRight: 6 }}></i> Edit</button>}
                    {!viewOnly && <button type="button" onClick={() => dispatchSaveSupplier(addSupplier, (err) => { if (!err) setViewOnly(true); })} style={saveBtn}><i className="fas fa-save" style={{ marginRight: 6 }}></i> Save</button>}
                </div>
            </div>

            {!!error && <div style={{ margin: '10px 2px', color: 'var(--danger)', fontWeight: 600, fontSize: 14 }}>{error}</div>}

            {/* Content card */}
            <div style={{ marginTop: 14, background: 'rgba(255,255,255,0.72)', border: '1px solid var(--glass-border)', borderRadius: 16, boxShadow: '0 8px 24px rgba(15,31,46,0.05)', padding: '20px 22px' }}>
                <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.5px', textTransform: 'uppercase', color: 'var(--text-secondary)', borderBottom: '2px solid var(--primary)', paddingBottom: 8, marginBottom: 16, display: 'inline-block' }}>Details</div>
                {activeTab == 'details' && (
                    <ItemEditComponent prop={'name'} onChangeText={onChangeText} type={'name'} header={'Name'} value={addSupplier['name']} />
                )}
            </div>
        </div >
    )
};

class SupplierScreen extends React.Component {
    setSupplier = () => {

        if (this.props.supplier) {
            return { ...this.props.supplier };
        }

        return {};
    }
    setViewOnly = () => {

        if (this.props.supplier) return true;

        return false;
    }

    state = {
        addSupplier: this.setSupplier(),
        viewOnly: false,
        activeTab: 'details',
        dirty: false
    }

    // true = no unsaved changes (gates the discard-on-back confirm)
    compare = () => !this.state.dirty;

    onChangeText = (key, value) => {
        let newSupplier = {
            ...this.state.addSupplier,
            [key]: value
        };

        this.setState({
            ...this.state,
            addSupplier: {
                ...newSupplier
            },
            dirty: true
        });
    }

    componentWillMount() {

    }

    setViewOnly = (vo) => {
        this.setState({
            viewOnly: vo
        });
    }

    setActiveTab = (vo) => {
        this.setState({
            activeTab: vo
        });
    }

    cancelChanges = () => {
        this.setState({
            addSupplier: this.setSupplier(),
            dirty: false
        });
    }


    render() {
        return (
            <div>
                <SupplierComponent
                    {...this.state}
                    compare={this.compare}
                    setViewOnly={this.setViewOnly}
                    onChangeText={this.onChangeText}
                    cancelChanges={this.cancelChanges}
                    setActiveTab={this.setActiveTab}
                    onBoundsChanged={this.onBoundsChanged}
                    onMapMounted={this.onMapMounted}
                    onSearchBoxMounted={this.onSearchBoxMounted}
                    onPlacesChanged={this.onPlacesChanged}
                    {...this.props} />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    authUser: state.auth.user,
    supplier: state.suppliers.supplier,
    error: state.suppliers.error,
    selectedSupplierId: state.suppliers.selectedSupplierId
})

const mapDispatchToProps = {
    dispatchGetSupplier: (id) => getSupplier(id),
    dispatchDeleteSupplier: (id, navigate) => deleteSupplier(id, navigate),
    dispatchSaveSupplier: (id, callback) => createSupplier(id, callback),
    dispatchSelectAppointment: (appointment) => selectAppointment(appointment),
}

export default connect(mapStateToProps, mapDispatchToProps)(SupplierScreen)
